export const GET_TRANG_THAI_DATA_START = "GET_TRANG_THAI_DATA_START"
export const GET_TRANG_THAI_DATA_SUCCESS = "GET_TRANG_THAI_DATA_SUCCESS"
export const GET_TRANG_THAI_DATA_ERROR = "GET_TRANG_THAI_DATA_ERROR"